import { createSlice } from '@reduxjs/toolkit';
import { fetchMyInvitations, fetchSentInvitations, acceptInvitation, declineInvitation, cancelInvitation, sendInvitation } from '../actions/invitation';

const invitationSlice = createSlice({
    name: 'invitation',
    initialState: {
        loading: false,
        my: [],
        sent: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchMyInvitations.fulfilled, (state, action) => {
            state.my = action.payload;
        })
        .addCase(fetchSentInvitations.pending, (state) => { state.loading = true })
        .addCase(fetchSentInvitations.fulfilled, (state, action) => {
            state.loading = false;
            state.sent = action.payload;
        })
        .addCase(fetchSentInvitations.rejected, (state) => { state.loading = false })
.addCase(acceptInvitation.fulfilled, (state, action) => {
            state.my = state.my.filter(i => i._id !== action.payload);
        })
        .addCase(declineInvitation.fulfilled, (state, action) => {
            state.my = state.my.filter(i => i._id !== action.payload);
        })
        .addCase(cancelInvitation.fulfilled, (state, action) => {
            state.sent = state.sent.filter(i => i._id !== action.payload);
        });
    }
});

export default invitationSlice.reducer;
